import {gettext} from "@/utils/translate";

export const Gender = {
    MALE: 'MALE',
    FEMALE: 'FEMALE',
};

export const GenderLabel = {
    MALE: gettext('Male'),
    FEMALE: gettext('Female'),
}

export const IsChild = {
    ADULT: false,
    CHILD: true,
}

export const IsChildLabel = {
    [IsChild.ADULT]: pgettext('label', 'adult'),
    [IsChild.CHILD]: pgettext('label', 'child'),
};

export const YesNo = {
    NO: 0,
    YES: 1
}

export const YesNoLabels = {
    0: gettext('No'),
    1: gettext('Yes'),
}

export const UnitType = {
    RV: 1,
    RLP: 2,
    RZP: 3,
    LZS: 4,
    DZS: 5,
    HZS: 6,
    OTHER: 99,
}

export const UnitTypeLabel = {
    1: pgettext('ems unit type', 'RV'),
    2: pgettext('ems unit type', 'RLP'),
    3: pgettext('ems unit type', 'RZP'),
    4: pgettext('ems unit type', 'LZS'),
    5: pgettext('ems unit type', 'DZS'),
    6: pgettext('ems unit type', 'HZS'),
    99: pgettext('ems unit type', 'Other'),
}

export const FirstResponderType = {
    PUBLIC_FR: 1,
    HZS: 2,
    PCR: 3,
    HS: 4,
    NPS: 5,
    VZS: 6,
    MP: 7,
    OTHER: 99,
}

export const FirstResponderTypeLabels = {
    1: pgettext('first responder type', 'Public FR'),
    2: pgettext('first responder type', 'Firemen'),
    3: pgettext('first responder type', 'Police'),
    4: pgettext('first responder type', 'Mountain Rescue'),
    5: pgettext('first responder type', 'National Park Šumava'),
    6: pgettext('first responder type', 'Water Rescue'),
    7: pgettext('first responder type', 'City Police'),
    99: pgettext('first responder type', 'Other'),
}

export const WorkerType = {
    VOS: 1,
    FLIGHT_ATTENDANT: 2,
    OPERATOR: 3,
    FRONTLINE: 4,
    IN_TRAINING: 5,
}

export const WorkerTypeLabels = {
    1: pgettext('worker type', 'VOS'),
    2: pgettext('worker type', 'Flight attendant'),
    3: pgettext('worker type', 'Operator'),
    4: pgettext('worker type', 'Frontline'),
    5: pgettext('worker type', 'In Training'),
}

export const CompanyWorkerType = {
    AUTOMECHANIK: 'automechanik',
    LEKAR: 'lekar',
    OPERATOR: 'operator',
    REFERENT: 'referent',
    RIDIC: 'ridic',
    SZP: 'szp',
    UKLIZEC: 'uklizec',
    INSPEKTOR: 'inspektor',
}

export const CompanyWorkerTypeLabels = {
    'automechanik': pgettext('company worker type', 'automechanik'),
    'lekar': pgettext('company worker type', 'lekar'),
    'operator': pgettext('company worker type', 'operator'),
    'referent': pgettext('company worker type', 'referent'),
    'ridic': pgettext('company worker type', 'ridic'),
    'szp': pgettext('company worker type', 'szp'),
    'uklizec': pgettext('company worker type', 'uklizec'),
    'inspektor': pgettext('company worker type', 'inspektor'),
}

export const PoliceVerification = {
    UNVERIFIED: 1,
    VERIFIED: 2,
    UNABLE: 3,
}

export const PoliceVerificationLabels = {
    1: pgettext('police_verification', 'unverified'),
    2: pgettext('police_verification', 'verified'),
    3: pgettext('police_verification', 'unable'),
}
